import React from 'react';
import { Link } from 'react-router-dom';
import { BRAND, ROUTES } from '@/lib/constants';
import { FOOTER } from '@/constants/testIds';

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="border-t border-[var(--ns-border)] bg-[var(--ns-bg-2)] mt-16">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">
          <div
            className="flex flex-col gap-3 max-w-sm"
            data-testid={FOOTER.brand}
          >
            <img
              src={BRAND.logoUrl}
              alt="NetScouters"
              className="h-8 w-auto"
              draggable={false}
            />
            <p className="text-sm text-[var(--ns-text-muted)] leading-relaxed">
              {BRAND.tagline}. La plataforma que da visibilidad al deporte de
              clubes, cantera y competiciones locales.
            </p>
          </div>

          <div className="grid grid-cols-2 sm:grid-cols-3 gap-6 sm:gap-10 text-sm">
            <div className="flex flex-col gap-2">
              <span className="text-[var(--ns-text-subtle)] uppercase text-[11px] tracking-widest mb-1">
                Plataforma
              </span>
              <Link
                to={ROUTES.clubs}
                className="text-[var(--ns-text)] hover:text-[var(--ns-gold-600)] transition-colors"
              >
                Clubes
              </Link>
              <Link
                to={ROUTES.events}
                className="text-[var(--ns-text)] hover:text-[var(--ns-gold-600)] transition-colors"
              >
                Partidos
              </Link>
              <Link
                to={ROUTES.login}
                className="text-[var(--ns-text)] hover:text-[var(--ns-gold-600)] transition-colors"
              >
                Acceder
              </Link>
            </div>
            <div className="flex flex-col gap-2">
              <span className="text-[var(--ns-text-subtle)] uppercase text-[11px] tracking-widest mb-1">
                Legal
              </span>
              <Link
                to={ROUTES.legal}
                className="text-[var(--ns-text)] hover:text-[var(--ns-gold-600)] transition-colors"
                data-testid={FOOTER.legalLink}
              >
                Aviso legal
              </Link>
              <Link
                to={ROUTES.privacy}
                className="text-[var(--ns-text)] hover:text-[var(--ns-gold-600)] transition-colors"
                data-testid={FOOTER.privacyLink}
              >
                Privacidad
              </Link>
              <Link
                to={ROUTES.cookies}
                className="text-[var(--ns-text)] hover:text-[var(--ns-gold-600)] transition-colors"
                data-testid={FOOTER.cookiesLink}
              >
                Cookies
              </Link>
            </div>
            <div className="flex flex-col gap-2">
              <span className="text-[var(--ns-text-subtle)] uppercase text-[11px] tracking-widest mb-1">
                Contacto
              </span>
              <span className="text-[var(--ns-text-muted)]">
                soporte@netscouters.tv
              </span>
              <span className="text-[var(--ns-text-subtle)] text-xs mt-1">
                Fase 00 · v0.0.1
              </span>
            </div>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-[var(--ns-border)] flex flex-col sm:flex-row gap-3 sm:items-center sm:justify-between text-xs text-[var(--ns-text-subtle)]">
          <span>© {year} NetScouters. Todos los derechos reservados.</span>
          <span>Hecho para el deporte base.</span>
        </div>
      </div>
    </footer>
  );
};
